import React from 'react'

import { BrandedAlertModal } from 'components/Modal'
import type { BrandedAction } from 'components/Modal/BrandedAlertModal/BrandedAlertModal'
import { PopupLink } from "../CandidateView.styles";

interface CandidateScoreInfoProps {
    isOpen: boolean
    onConfirm: () => void
    onLink: () => void
    onClose?: () => void
}

// T2-6550: the "Recommendation Score" (What's this?) info modal now uses the
// shared BrandedAlertModal so it matches the TempStars design system (centered,
// constrained-width card) instead of the old full-width Popup dialog.
const CandidateScoreInfo = ({
    isOpen,
    onConfirm,
    onLink,
    onClose,
}: CandidateScoreInfoProps) => {
    const actions: BrandedAction[] = [
        {
            label: 'OK',
            variant: 'primary',
            onClick: onConfirm,
            ariaLabel: 'candidate-score-info-confirm-button',
        },
    ]

    return (
        <BrandedAlertModal
            isOpen={isOpen}
            onClose={onClose ?? onConfirm}
            title="Recommendation Score"
            ariaLabel="Recommendation Score"
            actions={actions}
        >
            <p>We use the power of 1000's of completed temping placements and reviews to calculate this Recommendation Score.</p>
            <br/>
            <p>It's based on this candidates track record of reviews, reliability and any work history this candidate may have had with your office.</p>
            <br/>
            <PopupLink className="no-fastclick" onClick={onLink}>Learn more about our Recommendation Engine score</PopupLink>
        </BrandedAlertModal>
    )
}

export default CandidateScoreInfo;
